<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              label="基地："
              prop="baseId"
            >
              <a-select
                v-model="form.baseId"
                placeholder="请选择基地"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkoutConsumeRecord)"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item
              label="年月:"
              prop="time"
            >
              <a-range-picker
                :value="form.time"
                :placeholder="['开始月份', '结束月份']"
                format="YYYY-MM"
                :mode="rangePickerMode"
                @panelChange="selectMonthRange"
                @change="monthChange"
              />
            </a-form-model-item>

            <a-form-model-item
              label="代金券编号："
              prop="voucherCode"
            >
              <a-input
                v-model="form.voucherCode"
                placeholder="请填写代金券编号"
              />
            </a-form-model-item>

            <a-form-model-item
              label="代金券名称："
              prop="voucherName"
            >
              <a-input
                v-model="form.voucherName"
                placeholder="请填写代金券名称"
              />
            </a-form-model-item>
          </a-form-model>
        </div>

        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @check="checkoutConsumeRecord"
            @checkExecp="checkExecp"
          />
        </div>
      </div>
      <div class="search-form-right">
        <TableActions
          :actions="rightActions"
          @importData="ImportTables"
          @export="exportConsumeRecord"
        />
      </div>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => index"
        :scroll="{ x: 1200 }"
        @change="handleTableChange"
      >
        <template
          slot="ratio"
          slot-scope="text, record"
        >
          {{ record.ratio + '%' }}
        </template>

        <template
          slot="taxRate"
          slot-scope="text, record"
        >
          {{ record.taxRate + '%' }}
        </template>

        <template
          slot="date"
          slot-scope="date"
        >
          {{ moment(date).format('YYYY-MM') }}
        </template>

        <template
          slot="monthStart"
          slot-scope="monthStart"
        >
          {{ monthStart ? moment(monthStart).format('YYYY-MM-DD HH:mm:ss') : null }}
        </template>

        <template
          slot="monthEnd"
          slot-scope="monthEnd"
        >
          {{ monthEnd ? moment(monthEnd).format('YYYY-MM-DD HH:mm:ss'): null }}
        </template>

        <span
          slot="actions"
          slot-scope="text, record"
        >
          <TableActions
            :actions="tableActions"
            :record="record"
            @edit="editRecord(record)"
          />
        </span>
      </a-table>
    </div>
    <EditbasicRecord
      :init-data="initData"
      :dialog-title="dialogTitle"
      :visible="modalVisible"
      :loading="confirmLoading"
      :base-options="baseOptions"
      :product-typetions="productTypetions"
      @cancel="handleCancel"
      @ok="handleOk"
    />
    <ImportTables
      :visible="importVisible"
      :loading="confirmLoading"
      @importCancel="handleCancel"
      @importOk="handleOk"
    />
  </div>
</template>

<script>
import { queryConsumeRecord, exportConsumeRecord } from '@/api/vocherIncome.js'
import moment from 'moment'
import ImportTables from './ImportTables.vue'
import { pagination } from '@/constants/tableSetting'

import {
  queryBases,
  queryAllProductTypes
} from '@/api/common.js'

import EditbasicRecord from './EditBasicRecord.vue'
import { excelDown, filterOption, inputKeydown } from '@/utils/utils.js'

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'check'
  },
  {
    title: '异常信息查询',
    action: 'checkExecp',
    type: 'primary'
  }
]

const rightActions = [
  {
    title: '导入',
    action: 'importData',
    type: 'primary',
    ghost: true,
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '导出',
    type: 'primary',
    action: 'export',
    ghost: true,
    apis: ['@baseInfo/Export_Bases']
  }
]
const columns = [
  {
    title: '基地',
    dataIndex: 'baseName',
    key: 'baseName',
    width: '130px'
  },
  {
    title: '配比',
    dataIndex: 'ratio',
    key: 'ratio',
    width: '130px',
    scopedSlots: { customRender: 'ratio' }
  },
  {
    title: '计收时间',
    dataIndex: 'date',
    key: 'date',
    width: '120px',
    scopedSlots: { customRender: 'date' }
  },
  {
    title: '当月税前收入',
    dataIndex: 'preTaxAmount',
    key: 'preTaxAmount',
    width: '130px'
  },
  {
    title: '代金券实例号',
    dataIndex: 'voucherCode',
    key: 'voucherCode',
    width: '160px'
  },
  {
    title: '税率',
    dataIndex: 'taxRate',
    key: 'taxRate',
    width: '140px',
    scopedSlots: { customRender: 'taxRate' }
  },
  {
    title: '面额',
    dataIndex: 'denomination',
    key: 'denomination',
    width: '140px'
  },
  {
    title: '消耗额',
    dataIndex: 'consumptionAmount',
    key: 'consumptionAmount',
    width: '150px'
  },
  {
    title: '公司名',
    dataIndex: 'enterpriseName',
    key: 'enterpriseName',
    width: '150px'
  },
  {
    title: '代金券名称',
    dataIndex: 'voucherName',
    key: 'voucherName',
    width: '150px'
  },
  {
    title: 'ssn',
    dataIndex: 'ssn',
    key: 'ssn',
    width: '150px'
  },
  {
    title: '月开始时间',
    dataIndex: 'monthStart',
    key: 'monthStart',
    width: '150px',
    scopedSlots: { customRender: 'monthStart' }
  },
  {
    title: '月结束时间',
    dataIndex: 'monthEnd',
    key: 'monthEnd',
    width: '150px',
    scopedSlots: { customRender: 'monthEnd' }
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: '150px',
    scopedSlots: { customRender: 'actions' },
    fixed: 'right'
  }
]

const tableActions = [
  {
    title: '编辑',
    type: 'link',
    action: 'edit',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '删除',
    type: 'link',
    action: 'delete',
    apis: ['@baseInfo/Add_Base']
  }
]
export default {
  components: {
    EditbasicRecord,
    ImportTables
  },
  data () {
    return {
      columns,
      dataSource: [],
      loading: false,
      pagination,
      baseId: 0,
      baseOptions: [],
      productTypetions: [],
      tableActions,
      rightActions,
      modalVisible: false,
      importVisible: false,
      confirmLoading: false,
      initData: null,
      dialogTitle: null,
      form: {
        baseId: undefined,
        productTypeId: undefined,
        time: [],
        voucherName: undefined,
        voucherCode: undefined
      },
      isopen: false,
      rangePickerMode: ['month', 'month'],
      headerActions,
      isExecp: 0 // 非异常信息
    }
  },
  created () {
    this.loading = true
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    moment,
    excelDown,
    inputKeydown,
    filterOption,
    async fetchSearchOptions () {
      await queryBases().then((data) => {
        this.baseOptions = data
        this.baseOptions.unshift({
          baseId: '-1',
          baseName: '测试'
        })
      })
      await queryAllProductTypes().then((data) => {
        this.productTypetions = data
      })
    },
    // 异步获取数据
    async fetchData () {
      this.loading = true
      await queryConsumeRecord({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.form
      }).then((data) => {
        this.dataSource = data.result ? data.result : []
        this.pagination.total = data.totalRecords
      })
      this.loading = false
    },
    monthChange (value) {
      if (value.length === 0) {
        this.form.startYearMonth = null
        this.form.endYearMonth = null
        this.form.time = value
      }
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      if (!this.isExecp) {
        this.fetchData()// 获取表格数据的接口
      } else {
        this.checkExecp()
      }
    },
    ImportTables () {
      this.importVisible = true
      this.fetchData()
    },
    async exportConsumeRecord () {
      await exportConsumeRecord({
        ...this.form
      }).then((data) => {
        this.excelDown(data, '基础服务账单')
      })
    },
    checkoutConsumeRecord () {
      this.pagination.current = 1
      this.fetchData()
      this.isExecp = 0
    },
    checkExecp () {
      // this.pagination.current = 1
      this.loading = true
      this.isExecp = 1
      queryConsumeRecord({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.form,
        baseId: '-2'
      }).then((data) => {
        this.dataSource = data.result ? data.result : []
        this.pagination.total = data.totalRecords
      })
      this.loading = false
    },
    editRecord (record) {
      this.initData = record
      this.modalVisible = true
    },
    selectMonthRange (value) {
      this.form.startYearMonth = value[0].format('YYYY-MM')
      this.form.endYearMonth = value[1].format('YYYY-MM')
      this.form.time = [this.form.startYearMonth, this.form.endYearMonth]
    },
    handleCancel () {
      this.modalVisible = false
      this.importVisible = false
    },
    handleOk () {
      this.handleCancel()
      if (!this.isExecp) {
        this.fetchData()// 获取表格数据的接口
      } else {
        this.checkExecp()
      }
    }
  }

}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}
</style>
